<template>
    <div id="app">
        <div :id="'page-' + $route.name">
            <navbar></navbar>

            <router-view keep-alive :key="$route.name"></router-view>
            <page-transition></page-transition>

            <main-footer></main-footer>
        </div>
    </div>
</template>

<script>
import Navbar from './core/Navbar.vue'
import MainFooter from './core/Footer.vue'
import PageTransition from './core/PageTransition'

export default {
    components: {
        Navbar,
        MainFooter,
        PageTransition,
    },

    metaInfo: {
        title: 'Supra Net',
        titleTemplate: '%s | Supra Net - to make IT simple',
        meta: [
            {
                vmid: 'og:title',
                property: 'og:title',
                content: 'Supranet'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Supranet'
            },
            {
                vmid: 'description',
                name: 'description',
                content: 'Tvrtka Supra Net je specijalizirana za poslove projektiranja, instalacije i dokumentiranja pasivnih telekomunikacijskih mreža i elektroenergetskih sustava niskog napona'
            },
            {
                vmid: 'og:description',
                property: 'og:description',
                content: 'Tvrtka Supra Net je specijalizirana za poslove projektiranja, instalacije i dokumentiranja pasivnih telekomunikacijskih mreža i elektroenergetskih sustava niskog napona'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Tvrtka Supra Net je specijalizirana za poslove projektiranja, instalacije i dokumentiranja pasivnih telekomunikacijskih mreža i elektroenergetskih sustava niskog napona'
            },
            {
                vmid: 'og:type',
                property: 'og:type',
                content: 'website'
            },
            {
                vmid: 'og:url',
                property: 'og:url',
                content: process.env.URL + window.location.pathname
            }
        ]
    }
}
</script>
